/**
 * kit-inventory-check.js
 * Checks live inventory per component SKU and greys out OPTIS swatches
 * that fall below their configured minimum stock threshold.
 */

(function () {
  const APP_URL = "https://jedeborg-kit-inventory-app-production.up.railway.app";
  const CHECK_INTERVAL_MS = 60000;

  function waitForOptis(callback) {
    const observer = new MutationObserver(() => {
      const swatches = document.querySelectorAll(".bss-op-option");
      if (swatches.length > 0) { observer.disconnect(); callback(); }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    if (document.querySelectorAll(".bss-op-option").length > 0) {
      observer.disconnect(); callback();
    }
  }

  async function fetchKitMappings() {
    try {
      const res = await fetch(`${APP_URL}/api/kits`);
      return await res.json();
    } catch (e) {
      console.warn("[Kit Inventory] Could not fetch kit mappings", e);
      return {};
    }
  }

  async function fetchInventory(skus, thresholds) {
    if (!skus.length) return {};
    try {
      const params = new URLSearchParams({
        skus: skus.join(","),
        thresholds: JSON.stringify(thresholds)
      });
      const res = await fetch(`${APP_URL}/api/inventory?${params}`);
      return await res.json();
    } catch (e) {
      console.warn("[Kit Inventory] Could not fetch inventory", e);
      return {};
    }
  }

  function disableSwatch(el) {
    el.style.opacity = "0.35";
    el.style.cursor = "not-allowed";
    el.style.pointerEvents = "none";
    el.setAttribute("data-kit-disabled", "true");
    el.setAttribute("title", "Out of stock");
    if (!el.querySelector(".kit-oos-line")) {
      const line = document.createElement("div");
      line.className = "kit-oos-line";
      line.style.cssText = `
        position: absolute; top: 50%; left: 0; right: 0;
        height: 2px; background: rgba(180,0,0,0.5);
        transform: rotate(-45deg); pointer-events: none;
      `;
      el.style.position = "relative";
      el.style.overflow = "hidden";
      el.appendChild(line);
    }
  }

  function enableSwatch(el) {
    el.style.opacity = "";
    el.style.cursor = "";
    el.style.pointerEvents = "";
    el.removeAttribute("data-kit-disabled");
    el.removeAttribute("title");
    const line = el.querySelector(".kit-oos-line");
    if (line) line.remove();
  }

  async function runInventoryCheck() {
    const mappings = await fetchKitMappings();

    // Build SKU list and threshold map from kit definitions
    const allSkus = [];
    const thresholds = {};

    Object.values(mappings).forEach(kit => {
      (kit.components || []).forEach(c => {
        if (c.sku && !allSkus.includes(c.sku)) {
          allSkus.push(c.sku);
          // Use the component's minStock, default 0
          thresholds[c.sku] = c.minStock ?? 0;
        }
      });
      if (kit.labelMap) {
        Object.entries(kit.labelMap).forEach(([, optionMap]) => {
          Object.values(optionMap).forEach(sku => {
            if (sku && !allSkus.includes(sku)) {
              allSkus.push(sku);
              thresholds[sku] = thresholds[sku] ?? 0;
            }
          });
        });
      }
    });

    if (!allSkus.length) return;

    const inventory = await fetchInventory(allSkus, thresholds);

    const swatches = document.querySelectorAll(".bss-op-option");
    swatches.forEach(swatch => {
      const optionValue =
        swatch.getAttribute("data-option-value") ||
        swatch.querySelector("[data-value]")?.getAttribute("data-value") ||
        swatch.textContent?.trim();

      let matchedSku = null;
      Object.values(mappings).forEach(kit => {
        if (kit.labelMap) {
          Object.values(kit.labelMap).forEach(optionMap => {
            if (optionMap[optionValue]) matchedSku = optionMap[optionValue];
          });
        }
      });

      if (matchedSku) {
        const inv = inventory[matchedSku];
        if (inv && !inv.inStock) {
          disableSwatch(swatch);
        } else {
          enableSwatch(swatch);
        }
      }
    });
  }

  if (window.location.pathname.includes("/products/")) {
    waitForOptis(() => {
      runInventoryCheck();
      setInterval(runInventoryCheck, CHECK_INTERVAL_MS);
    });
  }
})();